import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Modal,
   Button,
   Paper,
   Typography,
   Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable, { MTableAction } from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { faFileEdit, faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
import { useHistory } from 'react-router-dom';
import ManageLimitPointPerGroup from '../../../components/Modal/Limit/ManageLimitPointPerGroup';
import { GSBtoWording } from "../../../configs/helpers/GSBtoWording"

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function ManageLimitPoint(props) {
   const history = useHistory();
   const addActionRef = useRef();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [showModal, setShowModal] = useState(false);

   useEffect(() => {
      getData().then((res) => {
         let temp = transformedData(res);
         setData(temp);
      });
   }, []);

   const getData = () => {
      setIsLoading(true);
      return Axios.get('/GSB/dashboard/config/GetLimitPointConfigList')
         .then((response) => {
            return response.data.limitPointConfig;
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   const transformedData = (resp) => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value, index) => {
            return Object.assign(
               {},
               {
                  ...value,
                  order: index + 1,
               },
            );
         });
         setIsLoading(false);
         return formatted;
      } else {
         return [];
      }
   };

   const refreshData = () => {
      setData([]);
      setShowModal(false);
      getData().then((res) => {
         let temp = transformedData(res);
         setData(temp);
      });
   };

   /** update an item by set state (optional) */
   const updateItem = (order, whichvalue, newvalue) => {
      var index = data.findIndex((x) => x.order === order);

      let g = data[index];
      g[whichvalue] = newvalue;
      if (index === -1) {
         console.log('no match');
      } else setData([...data.slice(0, index), g, ...data.slice(index + 1)]);
   };

   const setModalStyle = (type, value) => {
      if (type === 'edit') {
         setMyModal(
            <ManageLimitPointPerGroup
               onSuccess={() => refreshData()}
               data={value}
               onClickClose={() => setShowModal(false)}
            />,
         );
      }
      setShowModal(!showModal);
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>Manage Limit Point</Typography>
            </Box>
         </Box>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'order',
                  title: '#',
               },
               {
                  field: 'positionGroupCode',
                  title: 'รหัสกลุ่มตำแหน่ง',
               },
               {
                  field: 'positionGroupName',
                  title: 'ขื่อกลุ่มตำแหน่ง',
               },
               {
                  field: 'positionCode',
                  title: 'รหัสตำแหน่ง',
               },
               {
                  field: 'positionName',
                  title: 'ชื่อตำแหน่ง',
               },
               {
                  field: 'isLimitP',
                  title: 'Limit P Flag',
                  width: 150,
                  render: (rowData) => (
                     <Checkbox
                        checked={rowData.isLimitP}
                        className='cursor--default'
                        disableRipple
                     />
                  ),
               },
               {
                  field: 'limitP',
                  title: 'Limit P',
                  width: 150,
               },
               {
                  field: 'isLimitGSB',
                  title: 'Limit GSB Way of Work Flag',
                  width: 150,
                  render: (rowData) => (
                     <Checkbox
                        checked={rowData.isLimitGSB}
                        className='cursor--default'
                        disableRipple
                     />
                  ),
               },
               {
                  field: 'limitGSB',
                  title: 'Limit GSB Way of Work',
                  width: 150,
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               actionsCellStyle: {
                  color: '#ccc',
               },
               addRowPosition: 'first',
               padding: 'dense',
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  deleteTooltip: 'ลบ',
                  editTooltip: 'แก้ไข',
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={'#00a2e8'}
                        icon={faFileEdit}
                     />
                  )),
                  onClick: (event, rowData) => {
                     setModalStyle('edit', rowData);
                  },
                  tooltip: 'แก้ไข',
               }),
            ]}
         />
      </Paper>
   );
}

export default ManageLimitPoint;
